import { BaseService } from './base.service';

export class ZoneService extends BaseService {
    baseUrl = '/zone';
}
